export default __webpack_public_path__ + "static/media/carts_light.2d14817f.svg";